import React from 'react';
import { useDispatch } from 'react-redux';
import { setSelectedStadium } from '../../store/slices/stadiumSelectionSlice';
import { nextPhase } from '../../store/slices/gamePhaseSlice';
import './StadiumSelection.css';
import { GameCard } from '../GameCard/GameCard';
import TuriaImage from '../../assets/images/turia.png';

const isAbsoluteUrl = (value) =>
  /^(https?:)?\/\//i.test(value) || value.startsWith('data:') || value.startsWith('blob:');

const resolveStadiumImage = (value) => {
  if (!value) return TuriaImage;
  if (isAbsoluteUrl(value)) return value;

  const base = String(process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
  const normalized = value.startsWith('/') ? value : `/${value}`;
  return base ? `${base}${normalized}` : normalized;
};

const StadiumSelection = ({ stadiums }) => {
  const dispatch = useDispatch();
  
  const handleSelectStadium = (stadium) => {
    dispatch(setSelectedStadium(stadium));
    dispatch(nextPhase());
  };

  return (
    <div className="stadium-selection-container">
      <p className="stadium-selection-title">CHOOSE A STADIUM</p>
      <div className="stadium-list">
        {stadiums.map((stadium) => {
          const firstSlot = stadium.slots && stadium.slots[0];
          const dayOfWeek = firstSlot ? firstSlot.dayOfWeek : "Open Days Not Available";
          const capacity = stadium.capacity;

          const imageSrc = resolveStadiumImage(stadium.stadiumPicturePath);

          return (
            <div
              key={stadium._id} // or stadium.id
              className="stadium-card-wrapper"
              onClick={() => handleSelectStadium(stadium)}
            >
              <GameCard
                imageSrc={imageSrc}
                name={stadium.name}
                subtitle={stadium.address}
                dayOrDate={dayOfWeek}
                timeOrCapacity={capacity}
                id={stadium._id} // or stadium.id
                isGame={false}
                disableNavigation
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default StadiumSelection;
